'use client';

import { formatToHourAndMinutes } from './formatToHourAndMinutes';

export const formatToWeekdayPlusHourAndMinutes = (
  date: Date,
  locale: string,
): string => {
  const weekday = date.toLocaleString(locale, { weekday: 'short' });

  const time = formatToHourAndMinutes(date, locale);

  return `${weekday}, ${time}`;
};
